(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("CashierPaymentsWidget", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["CashierPaymentsWidget"] = factory(require("React"), require("ReactDOM"));
	else
		root["CashierPaymentsWidget"] = factory(root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_63__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition